import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateMuteStatusRecentChat } from '../../Actions/RecentChatActions';
import { getExpiredMutes, removeTempMute } from '../../Helpers/Chat/muteState';

const SWEEP_INTERVAL_MS = 30 * 1000;

/**
 * Clears mutes whose duration has elapsed while the app stays open.
 *
 * The server already stops withholding notifications on its own; this only keeps the
 * chat list from showing a bell for a mute that has ended. A reconnect reconciles the
 * same thing against the server, so this is the in-session half of that.
 */
const useMuteExpiry = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const sweep = () => {
            getExpiredMutes().forEach(chatId => {
                removeTempMute(chatId);
                dispatch(updateMuteStatusRecentChat({ fromUserId: chatId, isMuted: false }));
            });
        };

        sweep();
        const timer = setInterval(sweep, SWEEP_INTERVAL_MS);
        return () => clearInterval(timer);
    }, [dispatch]);
};

export default useMuteExpiry;
